import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {ArticleForm} from './components/ArticleForm'
import {ModeleArticle} from '../../../components/Models'

type LocationState = {
  data: ModeleArticle | undefined | null
}

const ArticlePage = () => {
  let {articleId} = useParams()

  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {articleId === undefined ? 'Créer' : 'Modifier'} un article
            </h3>
          </div>
        </div>

        <div>
          <ArticleForm id={articleId} data={state ? state.data : null} />
        </div>
      </div>
    </>
  )
}

export {ArticlePage}
